import React, {useEffect, useRef} from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';
import {Table} from '@udemy/react-structure-components';
import {
    TableColumn,
    TableRow,
} from '@udemy/react-structure-components/dist/@types/table/table.react-component';

import {EnrolledCourses} from '../types/enrolledCourses';
import styles from './assertions-page.module.less';

interface CoursesListProps {
    courses: EnrolledCourses[];
}

export const CoursesList = ({courses}: CoursesListProps) => {
    const {gettext} = useI18n();
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false; // Set to false when the component unmount
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps -- only run once

    const tableColumns = [
        {
            fieldName: 'title',
            headerName: gettext('Course name'),
        },
        {
            fieldName: 'minutes_watched',
            headerName: gettext('Minutes watched'),
        },
    ];

    const renderRow = (
        columns: TableColumn[],
        rows: TableRow[],
        row: TableRow,
        rowIndex: number,
    ) => {
        const course = row as EnrolledCourses;
        return (
            <tr key={rowIndex}>
                <td className={styles['course-name-and-image']}>
                    <Image
                        alt={course.title}
                        src={course.image_240x135}
                        className={styles['course-image']}
                    />
                    <a href={course.url}>{course.title}</a>
                </td>
                <td>{course.minutes_consumed}</td>
            </tr>
        );
    };

    return (
        <Table
            data-testid="course-list-table"
            className={styles['course-list-table']}
            data-purpose={'course-list-table'}
            columns={tableColumns}
            rows={courses}
            renderRow={renderRow}
        />
    );
};
